import { NBN_SESSION_KEYS, PUBLIC_PAGES } from '@belong/constants/src';
import { getValuesFromSessionStorage } from '@belong/session-storage';
import { ISqModel } from '@belong/types/nbn';

export const getTechTypeForPostSq = (pathname: string): Record<string, any> | undefined => {
  if (pathname !== PUBLIC_PAGES.NBN_PLANS_SQ) {
    return undefined;
  }

  const sq = getValuesFromSessionStorage<ISqModel>(NBN_SESSION_KEYS.SQ_MODEL);
  if (!sq?.broadbandTechType) {
    return undefined;
  }

  return { techType: sq?.broadbandTechType };
};
